const PaymentTypes = {
  GIFT_AFTER_PAY: 'GIFT_AFTER_PAY',
  BILLING_PAYMENT: 'BILLING_PAYMENT',
  SETUP_AUTO_BILL: 'SETUP_AUTO_BILL',
  SETUP_AUTO_TOP_UP: 'SETUP_AUTO_TOP_UP',
  EDIT_AUTO_BILL: 'EDIT_AUTO_BILL',
  EDIT_AUTO_TOP_UP: 'EDIT_AUTO_TOP_UP',
  BALANCE_TOP_UP: 'BALANCE_TOP_UP',
  TOP_UP_SOMEONE_ELSE: 'TOP_UP_SOMEONE_ELSE',
  VOUCHER_TOP_UP: 'VOUCHER_TOP_UP',
};
const PaymentScreenTypes = {
  DEFAULT: 'default',
  PAYMENTREQUEST: 'paymentRequest',
  SUCCESSOFFERGIFT: 'successOfferGift',
  ADDDATAOFFER: 'addDataOffer',
  UPGRADETOOFFER: 'upgradeToOffer',
  PAYMENTSUCCESSFULLY: 'paymentSuccessfully',
  PAYMENTFAILD: 'PaymentFaild',
  DATAADDED: 'dataAdded',
  OFFERGIFT: 'offerGift',
  ADD_PAYMENT_CARD: 'ADD_PAYMENT_CARD',
  ADD_PAYMENT_CARD_LOADING: 'ADD_PAYMENT_CARD_LOADING',
  SETUP_AUTO_BILL: 'SETUP_AUTO_BILL',
  SETUP_AUTO_BILL_SUCCESS: 'SETUP_AUTO_BILL_SUCCESS',
  SETUP_AUTO_BILL_ERROR: 'SETUP_AUTO_BILL_ERROR',
  SETUP_AUTO_BILL_LOADING: 'SETUP_AUTO_BILL_LOADING',
  SETUP_AUTO_TOP_UP: 'SETUP_AUTO_TOP_UP',
  SETUP_AUTO_TOP_UP_LOADING: 'SETUP_AUTO_TOP_UP_LOADING',
  SETUP_AUTO_TOP_UP_SUCCESS: 'SETUP_AUTO_TOP_UP_SUCCESS',
  SETUP_AUTO_TOP_UP_ERROR: 'SETUP_AUTO_TOP_UP_ERROR',
  DEFAULT_ERROR: 'DEFAULT_ERROR',
  TOP_UP_SOMEONE_ELSE: 'TOP_UP_SOMEONE_ELSE',
  TOP_UP_SOMEONE_ELSE_LOADING: 'TOP_UP_SOMEONE_ELSE_LOADING',
  TOP_UP_SOMEONE_ELSE_SUCCESS: 'TOP_UP_SOMEONE_ELSE_SUCCESS',
  TOP_UP_SOMEONE_ELSE_ERROR: 'TOP_UP_SOMEONE_ELSE_ERROR',
  TOP_UP_SOMEONE_ELSE_CONTACT_LIST: 'TOP_UP_SOMEONE_ELSE_CONTACT_LIST',
  CUSTOM_AMOUNT: 'CUSTOM_AMOUNT',
  VOUCHER_INTIIAL_STATE: 'VOUCHER_INTIIAL_STATE',
  VOUCHER_SCAN_QR_STATE: 'VOUCHER_SCAN_QR_STATE',
  VOUVHER_TOP_UP_LOADING: 'VOUVHER_TOP_UP_LOADING',
  VOUCHER_TOP_UP_SUCCESS: 'VOUCHER_TOP_UP_SUCCESS',
  VOUCHER_TOP_UP_ERROR: 'VOUCHER_TOP_UP_ERROR',
};

export { PaymentTypes, PaymentScreenTypes };
